import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { changePassword } from 'actions/users';
import DeviseLayout from './DeviseLayout';

class ResettPasswordPage extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    // actions
    changePassword: PropTypes.func.isRequired,
  }

  onSubmit = (e) => {
    e.preventDefault();
    const password = this.password.value;
    const passwordConfirmation = this.passwordConfirmation.value;
    this.props.changePassword(this.props.history.location.search, { password, passwordConfirmation });
  }

  render() {
    return (
      <DeviseLayout allowAuthenticated title='Sparkler - Reset Password' subTitle='Change your password' cta='Change my password' onSubmit={this.onSubmit}>
        <div>
          <input
            name='sp-reset-password'
            ref={_ref => this.password = _ref}
            autoCapitalize="none"
            type="password"
            placeholder="New Password"
          />
          <input
            name='sp-reset-password-confirmation'
            ref={_ref => this.passwordConfirmation = _ref}
            autoCapitalize="none"
            type="password"
            placeholder="New Password Confirmation"
          />
        </div>
      </DeviseLayout>
    );
  }
}

export default connect(null, { changePassword })(ResettPasswordPage)
